import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';

export const getContactsLabel = (label: DatoCmsSignUp) => {
  return {
    titleContacts: label.titleSeventhForm,
    descriptionContacts: label.descriptionSeventhForm,
    email: label.email,
    placeholderEmail: label.placeholderEmail,
    optEmail: label.optEmail,
    nextButton: label.nextButton,
    telephone: label.telephone,
    placeholderTelephone: label.placeholderTelephone,
    optTelephone: label.optTelephone,
    sendAgainLabel: label.sendAgain,
    labelWaitTimeNewOtp: label.labelWaitTimeNewOtp,
  };
};
